<!--C2-迭代需求 #42892（分期计算器H5设计）-->
<template>
  <div @click="show">
    <slot>
      <!-- 插槽 -->
    </slot>
    <vcar-popup @close="hide" :visible="visible">
      <div class="action-sheet-content">
        <div class="action-sheet-header flex">
          <div @click="preCheck">
            {{
              valueTemp.length > 0
                ? valueTemp[valueTemp.length - 1].label
                : "选择品牌"
            }}
          </div>
          <img
            class="close-btn"
            src="../../../assets/image/VcarCalculator/close.png"
            @click="hide"
          />
        </div>
        <div class="action-sheet-listbox">
          <div
            v-for="item in showColumns"
            :key="item.value"
            :class="[
              'action-sheet-item',
              'flex',
              item.between ? 'between' : '',
            ]"
            @click="checked(item)"
          >
            <img
              v-if="item.carBrandImgMin"
              class="car-cover"
              :src="item.carBrandImgMin"
            />
            <div v-if="item.carBrand" class="car-name">
              {{ item.carBrand }}
            </div>
            <div v-if="item.carSeriesName" class="car-name-small">
              {{ item.carSeriesName }}
            </div>
            <div v-if="item.carModelName" class="car-name-small">
              {{ item.carModelName }}
            </div>
            <div v-if="item.carPriceMin" class="car-price">
              指导价:
              <span class="bold">
                {{ fttPrice(item.carPriceMin) }}-
                {{ fttPrice(item.carPriceMax) }}</span
              >
            </div>
            <div v-if="item.carPrice" class="car-price">
              指导价:
              <span class="bold">{{ fttPrice(item.carPrice) }}</span>
            </div>
          </div>
        </div>
      </div>
    </vcar-popup>
  </div>
</template>

<script>
import VcarPopup from "./VcarPopup";
export default {
  data() {
    return {
      value: [null, null, null], //分别代表唯一id
      valueTemp: [],
      visible: false,
      actionColumns: [],
      showColumns: [],
    };
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    VcarPopup,
  },
  watch: {
    columns: {
      immediate: true,
      handler(newVal, oldVal) {
        this.setActionColumns(newVal);
      },
    },
    visible(newVal, oldVal) {
      if (!newVal) {
        this.preCheck(true);
      }
    },
  },
  methods: {
    show(e) {
      e && e.stopPropagation();
      this.visible = true;
    },
    hide(e) {
      e && e.stopPropagation();
      this.visible = false;
    },
    onChange(val, visible = false) {
      this.$emit("change", val || this.valueTemp);
      this.visible = visible;
    },
    checked(val) {
      //决定是push还是=
      let size = this.valueTemp.length;
      if (size > 0 && !this.valueTemp[size - 1].children) {
        this.valueTemp[size - 1] = val;
      } else {
        this.valueTemp.push(val);
      }
      if (val.children) {
        this.showColumns = val.children;
      }
      if (!val.children) {
        this.onChange(this.valueTemp);
      }
    },
    preCheck(reset) {
      if (reset) {
        this.showColumns = this.actionColumns;
        this.valueTemp = [];
        return;
      }
      let size = this.valueTemp.length;
      if (size > 1) {
        if (this.valueTemp[size - 1].children) {
          this.showColumns = this.valueTemp[size - 2].children;
          this.valueTemp.splice(size - 1, 1);
        } else {
          this.showColumns = this.valueTemp[size - 3].children;
          this.valueTemp.splice(size - 2, 2);
        }
      } else {
        this.showColumns = this.actionColumns;
        this.valueTemp = [];
      }
    },
    /**
     * 对数据进行格式化
     */
    setActionColumns(columns = []) {
      for (var i = 0; i < columns.length; i++) {
        let series = columns[i].carSeries || [];
        for (var j = 0; j < series.length; j++) {
          let models = series[j].carModels || [];
          for (var k = 0; k < models.length; k++) {
            models[k].value = models[k].carModelId;
            models[k].label = series[j].carSeriesName;
          }
          series[j].value = series[j].carSeriesId;
          series[j].label = series[j].carSeriesName;
          series[j].children = models;
        }
        columns[i].value = columns[i].carBrandId;
        columns[i].label = columns[i].carBrand;
        columns[i].children = series;
        columns[i].between = true;
      }
      this.showColumns = columns;
      this.actionColumns = columns;
      if (columns.length > 0) {
        this.onChange([
          columns[0],
          columns[0].children[0],
          columns[0].children[0].children[0],
        ]);
      }
    },
    fttPrice(val = 0) {
      let dividend = 10000;
      let curentNum = val / dividend;
      return curentNum.toFixed(2) + "万";
    },
  },
};
</script>

<style scoped>

@font-face {  
  font-family: 'OPPOSans-M'; 
  src: url('../../../assets/font/OPPOSans-M.ttf');
  font-weight: normal;  
  font-style: normal;  
}

.flex {
  display: -moz-box;
  /* Firefox */
  display: -ms-flexbox;
  /* IE10 */
  display: -webkit-box;
  /* Safari */
  display: -webkit-flex;
  /* Chrome, WebKit */
  display: box;
  display: flexbox;
  display: flex;
}

div {
  box-sizing: border-box;
}

.action-sheet-content {
  width: 100%;
  background: #f7f7f7;
  border-radius: 0.2rem 0.2rem 0 0;
  padding: 0px 0.24rem 0.4rem 0.24rem;
}

.action-sheet-content .action-sheet-header {
  padding: 0.44rem 0 0.36rem;
  font-family: PingFangSC-Regular;
  font-size: 0.34rem;
  color: #717273;
  letter-spacing: 0;
  align-items: center;
  justify-content: space-between;
}

.action-sheet-content .action-sheet-header .close-btn {
  width: 0.48rem;
  height: 0.48rem;
  cursor: pointer;
}

.action-sheet-content .action-sheet-listbox {
  max-height: 7rem;
  overflow-x: auto;
}

.action-sheet-content .action-sheet-listbox .action-sheet-item {
  padding: 0.3rem;
  flex-direction: column;
  background: #ffffff;
  border-radius: 8px;
  margin-top: 0.2rem;
}

.action-sheet-content .action-sheet-listbox .action-sheet-item:first-child {
  margin-top: 0;
}

.action-sheet-content .action-sheet-listbox .between {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.action-sheet-content .action-sheet-listbox .action-sheet-item .car-cover {
  width: 1.72rem;
  height: auto;
}

.action-sheet-content .action-sheet-listbox .action-sheet-item .car-name {
  font-family: PingFangSC-Medium;
  font-size: 0.4rem;
  color: #465470;
  letter-spacing: 0;
  line-height: 1;
}

.action-sheet-content .action-sheet-listbox .action-sheet-item .car-name-small {
  font-family: PingFangSC-Medium;
  font-size: 0.28rem;
  color: #333333;
  letter-spacing: 0;
  line-height: 1;
}

.action-sheet-content .action-sheet-listbox .action-sheet-item .car-price {
  font-family: PingFangSC-Regular;
  font-size: 0.24rem;
  color: #999999;
  letter-spacing: 0;
  vertical-align: middle;
  margin-top: 0.1rem;
}

.action-sheet-content
  .action-sheet-listbox
  .action-sheet-item
  .car-price
  .bold {
  /* padding: 0 0 0 0.15rem; */
  font-family: OPPOSans-M;
  font-size: 0.24rem;
  color: #ff6932;
  letter-spacing: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/VcarCalculator/components/VcarActionSheet.vue